import React, { Component } from "react";
import { Form, Input, Button, Radio } from 'antd';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

class AddStateForm extends Component {
  render() {
    return (
      <Form
        {...layout}
        name="add-state"
        initialValues={{
          remember: true,
        }}
        onFinish={() =>{}}
      >
        <Form.Item
          label="State Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please input state name!',
            },
          ]}
        >
          <Input />
        </Form.Item>
  
        <Form.Item
          label="Biden value"
          name="biden"
          rules={[
            {
              required: true,
              message: 'Please input biden value!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Biden Color">
          <Radio.Group onChange={() =>{}} value={1}>
            <Radio value={1}>A</Radio>
            <Radio value={2}>B</Radio>
            <Radio value={3}>C</Radio>
            <Radio value={4}>D</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label="Trump value"
          name="trump"
          rules={[
            {
              required: true,
              message: 'Please input trum value!',
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Trump Color">
          <Radio.Group onChange={() =>{}} value={1}>
            <Radio value={1}>A</Radio>
            <Radio value={2}>B</Radio>
            <Radio value={3}>C</Radio>
            <Radio value={4}>D</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item {...tailLayout}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
    </Form>
    )
  }
}

export default AddStateForm;